import {StyleSheet} from "aphrodite";

import {View, type StyleType} from "@khanacademy/wonder-blocks-core";
import {mediaQueries} from "@khan/shared-styles";

interface Props {
    // The left side of the component
    leftComponent: React.ReactNode;
    // the right side of the component
    rightComponent: React.ReactNode;
    // styles applied to the container
    style?: StyleType;
    // styles applied to the left column
    leftColumnStyle?: StyleType;
    // styles applied to the right column
    rightColumnStyle?: StyleType;
}

/**
 * A layout with two columns. On small screens (xsOrSmaller), the left
 * component stacks above the right side component.
 */
export const LayoutTwoColumns = ({
    leftComponent,
    rightComponent,
    style,
    leftColumnStyle,
    rightColumnStyle,
}: Props) => {
    return (
        <View style={[styles.container, style]}>
            <View style={[styles.column, leftColumnStyle]}>
                {leftComponent}
            </View>
            <View style={[styles.column, rightColumnStyle]}>
                {rightComponent}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        [mediaQueries.xsOrSmaller]: {
            gridTemplateColumns: "1fr",
        },
    },
    column: {
        alignItems: "center",
    },
});
